/**
 * Caché en memoria para catálogos estables (materias, cursos, tipos de actividad).
 * Se invalida al iniciar o cerrar sesión Django.
 */
const store = new Map();

export function catalogCacheKey(name, params = {}) {
  const entries = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .sort(([a], [b]) => a.localeCompare(b));
  if (!entries.length) return name;
  return `${name}?${entries.map(([k, v]) => `${k}=${v}`).join('&')}`;
}

export function getCachedCatalog(key) {
  return store.get(key);
}

export function setCachedCatalog(key, data) {
  store.set(key, data);
}

export function clearEstudyooCatalogCache() {
  store.clear();
}
